/*
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2022-05-05 09:22:56
 * @Description: 
 */
/**
  * 头条 接口的出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const headline = {
    // 列表
    list (params) {
        return axios.get(api + 'headline/list', { params: params })
    },
    //添加
    create (params) {
        return axios.post(api + 'headline/create', qs.stringify(params))
    },
    //获取编辑信息
    detail (params) {
        return axios.post(api + 'headline/detail', qs.stringify(params))
    },
    //修改
    edit (params) {
        return axios.post(api + 'headline/edit', qs.stringify(params))
    },
    //删除
    remove (params) {
        return axios.post(api + 'headline/remove', qs.stringify(params))
    },
    //审核
    status (params) {
        return axios.post(api + 'headline/status', qs.stringify(params))
    },
    //推荐
    push (params) {
        return axios.post(api + 'headline/push', qs.stringify(params))
    },
    // 评论列表
    commentlist (params) {
        return axios.get(api + 'headline/commentlist', { params: params })
    },
    //更新状态
    commentstatus (params) {
        return axios.post(api + 'headline/commentstatus', qs.stringify(params))
    },
    //删除
    commentremove (params) {
        return axios.post(api + 'headline/commentremove', qs.stringify(params))
    },
    // 回复列表
    replycommentlist (params) {
        return axios.get(api + 'headline/replycommentlist', { params: params })
    },
}


// 导出接口
export default headline